import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function VSLSection() {
  const [showButton, setShowButton] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const handleTimeUpdate = () => {
    if (videoRef.current && videoRef.current.currentTime >= 20 && !showButton) {
      setShowButton(true);
    }
  };
  return <section className="min-h-screen bg-navy flex flex-col items-center justify-center p-4 relative overflow-hidden" data-id="element-228">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-20" data-id="element-229">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-sage blur-[100px]" data-id="element-230"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-terracotta blur-[100px]" data-id="element-231"></div>
      </div>

      <div className="w-full max-w-4xl mx-auto z-10 flex flex-col items-center" data-id="element-232">
        <h1 className="text-3xl md:text-5xl font-serif font-bold text-cream text-center mb-8 leading-tight text-balance" data-id="element-233">
          El método comprobado para que tu hijo deje las pantallas sin peleas
        </h1>

        <div className="w-full relative pt-[56.25%] rounded-2xl overflow-hidden shadow-2xl border-4 border-cream/10 bg-black" data-id="element-234">
          <video ref={videoRef} className="absolute top-0 left-0 w-full h-full object-contain" controls onTimeUpdate={handleTimeUpdate} src="https://cdn.magicpatterns.com/uploads/8Bun4DKv8RgFGU9P2dPf9e/vsl-2%20(1).mp4" data-id="element-235" />
        </div>

        <div className="h-24 mt-8 flex items-center justify-center w-full" data-id="element-236">
          {showButton && <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-237">
              <a href="https://rutinasimple.com//cart/52150541353241:1" className="bg-terracotta hover:bg-terracotta-dark text-white font-bold py-4 px-8 rounded-full shadow-xl transition-all duration-300 flex items-center gap-3 text-xl cta-pulse no-underline" data-id="element-238">
                Sí, quiero ver la oferta
                <ArrowRight className="w-6 h-6 animate-pulse" data-id="element-239" />
              </a>
            </motion.div>}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-cream/50 flex flex-col items-center animate-pulse z-10" data-id="element-240">
        <span className="text-xs uppercase tracking-widest mb-2 font-bold" data-id="element-241">
          Desliza para leer más
        </span>
        <ArrowRight className="w-5 h-5" data-id="element-242" />
      </div>
    </section>;
}